import * as tslib_1 from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import * as common from 'select2-component';
export * from 'select2-component';
import { indexTemplateHtml, indexTemplateHtmlStatic } from './variables';
var Select2 = /** @class */ (function (_super) {
    tslib_1.__extends(Select2, _super);
    function Select2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.option = null;
        _this.hoveringValue = null;
        _this.isOpen = false;
        _this.innerSearchText = '';
        _this.lastScrollTopIndex = 0;
        return _this;
    }
    Object.defineProperty(Select2.prototype, "searchText", {
        get: function () {
            return this.innerSearchText;
        },
        set: function (text) {
            if (this.customSearchEnabled) {
                this.$emit('search', text);
            }
            this.innerSearchText = text;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Select2.prototype, "dropdownStyle", {
        get: function () {
            return common.getDropdownStyle(this.isOpen);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Select2.prototype, "filteredData", {
        get: function () {
            var result = this.customSearchEnabled
                ? this.data
                : common.getFilteredData(this.data, this.searchText);
            if (common.valueIsNotInFilteredData(result, this.hoveringValue)) {
                this.hoveringValue = common.getFirstAvailableOption(result);
                if (this.resultsElement) {
                    var lastScrollTopIndex = common.getLastScrollTopIndex(this.hoveringValue, this.resultsElement, result, this.lastScrollTopIndex);
                    if (lastScrollTopIndex !== null) {
                        this.lastScrollTopIndex = lastScrollTopIndex;
                    }
                }
            }
            return result;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Select2.prototype, "containerStyle", {
        get: function () {
            return common.getContainerStyle(this.disabled, this.isOpen);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Select2.prototype, "selectionStyle", {
        get: function () {
            return common.getSelectionStyle(this.multiple);
        },
        enumerable: true,
        configurable: true
    });
    Select2.prototype.beforeMount = function () {
        var option = common.getOptionsByValue(this.data, this.value, this.multiple);
        if (option !== null) {
            this.option = option;
        }
        if (!Array.isArray(option)) {
            this.hoveringValue = this.value;
        }
        this.isSearchboxHidden = this.customSearchEnabled
            ? false
            : common.isSearchboxHiddex(this.data, this.minCountForSearch);
        this.searchStyle = common.getSearchStyle(this.isSearchboxHidden);
    };
    Select2.prototype.mounted = function () {
        this.searchInputElement = this.$refs.searchInput;
        this.resultsElement = this.$refs.results;
    };
    Select2.prototype.getOptionStyle = function (value) {
        return common.getOptionStyle(value, this.hoveringValue);
    };
    Select2.prototype.mouseenter = function (option) {
        if (!option.disabled) {
            this.hoveringValue = option.value;
        }
    };
    Select2.prototype.click = function (option) {
        if (!option.disabled) {
            this.select(option);
        }
        if (this.focusoutTimer) {
            clearTimeout(this.focusoutTimer);
        }
    };
    Select2.prototype.toggleOpenAndClose = function () {
        var _this = this;
        if (this.disabled) {
            return;
        }
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
            this.innerSearchText = '';
            Vue.nextTick(function () {
                _this.focusSearchboxOrResultsElement();
                if (_this.resultsElement) {
                    var lastScrollTopIndex = common.getLastScrollTopIndex(_this.hoveringValue, _this.resultsElement, _this.data, _this.lastScrollTopIndex);
                    if (lastScrollTopIndex !== null) {
                        _this.lastScrollTopIndex = lastScrollTopIndex;
                    }
                }
            });
            this.$emit('open');
        }
        if (this.focusoutTimer) {
            clearTimeout(this.focusoutTimer);
        }
    };
    Select2.prototype.focusout = function () {
        var _this = this;
        this.focusoutTimer = setTimeout(function () {
            _this.isOpen = false;
            _this.focusoutTimer = undefined;
        }, common.timeout);
    };
    Select2.prototype.select = function (option) {
        if (option !== null) {
            if (this.multiple) {
                var options = this.option;
                var index = options.findIndex(function (op) { return op.value === option.value; });
                if (index === -1) {
                    options.push(option);
                }
                else {
                    options.splice(index, 1);
                }
            }
            else {
                this.option = option;
                this.isOpen = false;
            }
        }
        this.$emit('update', this.multiple ? this.option.map(function (op) { return op.value; }) : this.option.value);
    };
    Select2.prototype.keyDown = function (e) {
        if (e.keyCode === 40) {
            this.moveDown();
            e.preventDefault();
        }
        else if (e.keyCode === 38) {
            this.moveUp();
            e.preventDefault();
        }
        else if (e.keyCode === 13) {
            this.selectByEnter();
            e.preventDefault();
        }
    };
    Select2.prototype.isSelected = function (option) {
        return common.isSelected(this.option, option, this.multiple);
    };
    Select2.prototype.isDisabled = function (option) {
        return option.disabled ? 'true' : 'false';
    };
    Select2.prototype.removeSelection = function (e, option) {
        var _this = this;
        common.removeSelection(this.option, option);
        this.$emit('update', this.option.map(function (op) { return op.value; }));
        e.preventDefault();
        e.stopPropagation();
        if (this.isOpen) {
            Vue.nextTick(function () {
                _this.focusSearchboxOrResultsElement();
            });
        }
        if (this.focusoutTimer) {
            clearTimeout(this.focusoutTimer);
        }
    };
    Select2.prototype.focusSearchboxOrResultsElement = function () {
        if (!this.isSearchboxHidden) {
            if (this.searchInputElement) {
                this.searchInputElement.focus();
            }
        }
        else {
            if (this.resultsElement) {
                this.resultsElement.focus();
            }
        }
    };
    Select2.prototype.moveUp = function () {
        this.hoveringValue = common.getPreviousOption(this.filteredData, this.hoveringValue);
        if (this.resultsElement) {
            var lastScrollTopIndex = common.getLastScrollTopIndex(this.hoveringValue, this.resultsElement, this.filteredData, this.lastScrollTopIndex);
            if (lastScrollTopIndex !== null) {
                this.lastScrollTopIndex = lastScrollTopIndex;
            }
        }
    };
    Select2.prototype.moveDown = function () {
        this.hoveringValue = common.getNextOption(this.filteredData, this.hoveringValue);
        if (this.resultsElement) {
            var lastScrollTopIndex = common.getLastScrollTopIndex(this.hoveringValue, this.resultsElement, this.filteredData, this.lastScrollTopIndex);
            if (lastScrollTopIndex !== null) {
                this.lastScrollTopIndex = lastScrollTopIndex;
            }
        }
    };
    Select2.prototype.selectByEnter = function () {
        if (this.hoveringValue) {
            var option = common.getOptionByValue(this.data, this.hoveringValue);
            this.select(option);
        }
    };
    Select2 = tslib_1.__decorate([
        Component({
            render: indexTemplateHtml,
            staticRenderFns: indexTemplateHtmlStatic,
            props: ['data', 'value', 'disabled', 'minCountForSearch', 'placeholder', 'customSearchEnabled', 'multiple']
        })
    ], Select2);
    return Select2;
}(Vue));
export { Select2 };
Vue.component('select2', Select2);
